module.exports = __webpack_public_path__ + "static/media/pensioner-3.ee3e3dd8.png";